import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_PAGE_SIZE } from '../components/dataTable/constants';
import { entityNames } from '../dao/dbConstants';
import { getDefaultOrderBy } from '../components/listScreen/columnUtils';

const getDefaultSearchParams = (entityName) => ({
  pageNumber: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  ...(getDefaultOrderBy(entityName)),
  searchQuery: '',
  filterValues: {},
  visibleFilterKeys: null,
  scopeCompanyIds: [],
  scopeProductIds: [],
});

let searchParams = {};
entityNames.forEach((entityName) => {
  searchParams[entityName] = getDefaultSearchParams(entityName);
});

const initialState = {
  searchParams: searchParams
};

const listOptionsSlice = createSlice({
  name: 'searchParams',
  initialState,
  reducers: {
    setSearchParams: (state, action) => {
      // INFO - entityNames are defined as constants in dao/dbConstants.js as ENTITY_NAME_XXX
      const { entityName, searchParams } = action.payload;
      state.searchParams[entityName] = { ...state.searchParams[entityName], ...searchParams };
    }
  },
});

export const { setSearchParams } = listOptionsSlice.actions;
export default listOptionsSlice.reducer;